import { render } from "./ProgramOfferedView.vue?vue&type=template&id=a08c2fdc"
import script from "./ProgramOfferedView.vue?vue&type=script&lang=js"
export * from "./ProgramOfferedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__